import { Button, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDownloadPdfFiles } from 'shared/mutations';
import { ContractRouteParams } from 'shared/types/routing';
import { addPdfExtension } from 'shared/utility';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useGetContract } from 'shared/queries';

export function CustomerInfoWidgetDownloadButton() {
  const { contractId } = useParams<ContractRouteParams>();
  const pdfDownloadMutation = useDownloadPdfFiles();
  const { contract } = useGetContract(contractId);

  if (!contract) {
    return null;
  }

  return (
    <Grid container item xs={3} justifyContent='end'>
      <Button
        aria-label='download contract'
        title='Download Contract File'
        variant='contained'
        endIcon={<OpenInNewIcon />}
        onClick={async () => {
          await pdfDownloadMutation.mutateAsync({
            fileId: addPdfExtension(contractId),
            originalFileName: contract.originalDocumentName,
          });
        }}
      >
        Download Contract
      </Button>
    </Grid>
  );
}
